import * as React from 'react';
import { ThemeConfig, Link } from 'docz';
import styled from 'react-emotion';
import { breakpoints } from '@styles/responsive';
import { get } from '@utils/theme';
const Wrapper = styled('div') `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 20px 30px;

  a,
  a:hover,
  a:visited {
    text-decoration: none;
  }

  @media screen and (max-width: ${breakpoints.desktop}px) {
    &:before {
      height: ${(p) => (p.showBg ? '3px' : 0)};
    }
  }
`;
const LogoImg = styled('img') `
  padding: 0;
`;
const LogoText = styled('h1') `
  margin: 5px 0;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.015em;
  color: ${get('colors.sidebarText')};
`;
export const Logo = ({ showBg }) => (React.createElement(ThemeConfig, null, ({ title, themeConfig: { logo } }) => (React.createElement(Wrapper, { showBg: showBg },
    React.createElement(Link, { to: "/" }, logo ? (React.createElement(LogoImg, { src: logo.src, width: logo.width, alt: title })) : (React.createElement(LogoText, null, title)))))));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvY29tcG9uZW50cy9zaGFyZWQvTG9nby9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUE7QUFFOUIsT0FBTyxFQUFFLFdBQVcsRUFBRSxJQUFJLEVBQUUsTUFBTSxNQUFNLENBQUE7QUFDeEMsT0FBTyxNQUFNLE1BQU0sZUFBZSxDQUFBO0FBRWxDLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxvQkFBb0IsQ0FBQTtBQUNoRCxPQUFPLEVBQUUsR0FBRyxFQUFFLE1BQU0sY0FBYyxDQUFBO0FBT2xDLE1BQU0sT0FBTyxHQUFHLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQTs7Ozs7Ozs7Ozs7Ozs7a0NBY0ssV0FBVyxDQUFDLE9BQU87O2dCQUVyQyxDQUFDLENBQWUsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQzs7O0NBRzFELENBQUE7QUFFRCxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUE7O0NBRTVCLENBQUE7QUFFRCxNQUFNLFFBQVEsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUE7Ozs7O1dBS2xCLEdBQUcsQ0FBQyxvQkFBb0IsQ0FBQztDQUNuQyxDQUFBO0FBTUQsTUFBTSxDQUFDLE1BQU0sSUFBSSxHQUFtQixDQUFDLEVBQUUsTUFBTSxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQ2xELG9CQUFDLFdBQVcsUUFDVCxDQUFDLEVBQUUsS0FBSyxFQUFFLFdBQVcsRUFBRSxFQUFFLElBQUksRUFBRSxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQ3JDLG9CQUFDLE9BQU8sSUFBQyxNQUFNLEVBQUUsTUFBTTtJQUNyQixvQkFBQyxJQUFJLElBQUMsRUFBRSxFQUFDLEdBQUcsSUFDVCxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQ04sb0JBQUMsT0FBTyxJQUFDLEdBQUcsRUFBRSxJQUFJLENBQUMsR0FBRyxFQUFFLEtBQUssRUFBRSxJQUFJLENBQUMsS0FBSyxFQUFFLEdBQUcsRUFBRSxLQUFLLEdBQUksQ0FDMUQsQ0FBQyxDQUFDLENBQUMsQ0FDRixvQkFBQyxRQUFRLFFBQUUsS0FBSyxDQUFZLENBQzdCLENBQ0ksQ0FDQyxDQUNYLENBQ1csQ0FDZixDQUFBIn0=